module.exports = __webpack_public_path__ + "img/add-file.186f3dfa.svg";